
import { useEffect } from 'react';
import Header from '@/components/Header';
import FooterSection from '@/components/FooterSection';
import StrategyHero from '@/components/strategy/StrategyHero';
import StrategyBenefits from '@/components/strategy/StrategyBenefits';
import StrategyDeliverables from '@/components/strategy/StrategyDeliverables';
import StrategyProcess from '@/components/strategy/StrategyProcess';
import StrategyDiscovery from '@/components/strategy/StrategyDiscovery';
import useSEO from '@/hooks/useSEO';
import { injectStructuredData, getLegalServiceSchema } from '@/utils/structuredData';

const Strategy = () => {
  // Enhanced SEO implementation
  useSEO({
    title: 'Strategy Consulting | DocketLabs',
    description: 'AI strategy consulting for law firms. Get a custom roadmap for implementing AI tools safely and effectively. Book your discovery session.',
    ogTitle: 'AI Strategy Consulting for Law Firms | DocketLabs',
    ogDescription: 'Get a custom AI roadmap for your law firm. Expert strategy consulting to implement AI tools safely and effectively. Book your discovery session today.',
    ogImage: '/lovable-uploads/Strategy-1.png',
    ogUrl: 'https://docketlabs.com/services/strategy',
    canonical: 'https://docketlabs.com/services/strategy',
    twitterTitle: 'AI Strategy Consulting for Law Firms',
    twitterDescription: 'Get a custom AI roadmap for your law firm. Expert strategy consulting to implement AI tools safely and effectively.',
  });

  useEffect(() => {
    // Inject service-specific structured data
    const serviceSchema = getLegalServiceSchema(
      'AI Strategy Consulting for Law Firms',
      'Custom AI roadmap and implementation strategy for legal practices. Expert consulting to safely and effectively integrate AI tools into your law firm.',
      'Legal Technology Consulting'
    );
    injectStructuredData(serviceSchema);
    
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow bg-background text-foreground">
        <StrategyHero />
        <StrategyBenefits />
        <StrategyDeliverables />
        <StrategyProcess />
        <StrategyDiscovery />
      </main>
      <FooterSection />
    </div>
  );
};

export default Strategy;
